import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getWebsiteBrandingFromSettings } from "../../utility/websiteBranding";
import "./websiteBrand.css";

function WebsiteBrandLogo({
  className = "website-brand-logo header_logo",
  alt,
  linkTo = "/",
  asLink = true,
}) {
  const siteData = useSelector((state) => state.settingsData);
  const settings = siteData?.settingData || {};
  const branding = useMemo(
    () => getWebsiteBrandingFromSettings(settings),
    [settings]
  );
  const [useFallback, setUseFallback] = useState(false);

  const imgSrc = useFallback ? branding.localLogoFallback : branding.logoUrl;
  const imgAlt = alt || branding.siteName;

  const image = (
    <img
      src={imgSrc}
      alt={imgAlt}
      className={className}
      onError={() => {
        if (!useFallback) setUseFallback(true);
      }}
    />
  );

  if (!asLink) return image;

  return (
    <a href={linkTo} className="website-brand-logo-link" aria-label={imgAlt}>
      {image}
    </a>
  );
}

export default WebsiteBrandLogo;
